import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import DemoBadge from '@/components/feature/DemoBadge';
import Watch from '@/pages/home/components/Watch';

export default function WatchPage() {
  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Header />
      <main>
        <section className="relative bg-foreground-950 pt-28 md:pt-40 pb-14 md:pb-20 px-4 md:px-8 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Aerial%20cinematic%20view%20of%20a%20winding%20Southern%20California%20golf%20course%20at%20sunset%20with%20long%20shadows%20across%20green%20fairways%2C%20deep%20moody%20tones%20with%20dark%20edges%20for%20text%20contrast%2C%20broadcast%20style%2C%20no%20people%20no%20logos&width=1920&height=1080&seq=gs-watch-hero&orientation=landscape"
            alt="Aerial view of a golf course"
            title="Watch GreenSide News"
            className="absolute inset-0 w-full h-full object-cover object-top opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/70 to-foreground-950/40"></div>
          <div className="relative">
            <div className="flex flex-wrap items-center gap-3">
              <p className="gs-rise font-label uppercase tracking-[0.25em] text-sm text-accent-400 font-bold">Watch</p>
              <DemoBadge label="Informational preview" tone="dark" />
            </div>
            <h1 className="gs-rise-2 font-heading font-extrabold uppercase text-background-50 text-5xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tight mt-2 max-w-5xl">
              Local golf, on camera.
            </h1>
            <p className="gs-rise-3 mt-5 text-background-200 text-base md:text-lg max-w-2xl">
              Course flyovers, pro tips and tournament coverage. This is where the GreenSide News video library will live.
            </p>
          </div>
        </section>

        <Watch />

        <section className="bg-background-100 px-4 md:px-8 py-14 md:py-20">
          <div className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-8 flex flex-col md:flex-row md:items-center justify-between gap-5">
            <div>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">Video sponsorship available</h2>
              <p className="mt-2 text-foreground-600 text-sm max-w-xl">The video series is one of the strongest sponsorship placements on the site — a single brand presents the whole channel.</p>
            </div>
            <Link to="/partners" className="bg-primary-500 hover:bg-primary-600 text-background-50 font-label font-bold uppercase tracking-wider text-sm px-5 py-3 rounded-md whitespace-nowrap cursor-pointer transition-colors shrink-0">Sponsor Watch</Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}